module.exports = __webpack_public_path__ + "static/img/fz_xe_ys.04b2cf4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/fz_xe_ys.png
// module id = 2mhU
// module chunks = 0